import React from 'react'
import { Modal } from '../../../components/_EOS/Modal'
import { ModalReturnType } from '../../../hooks/useModal'
import { Asn } from '../../../interfaces/Asn/Asn'
import { ModalAsnReceived } from '../../../components/ASN/AsnViewer/ModalAsn/ModalAsnReceived'

interface ASNReceiveExternalModalProps {
  receivedExternalModalState: ModalReturnType<Asn>
  onReceive: (asn: Asn, comment?: string, isReserve?: boolean) => void
  isLoading?: boolean
}

export const ASNReceiveExternalModal: React.FC<ASNReceiveExternalModalProps> = ({
  receivedExternalModalState,
  onReceive,
  isLoading = false
}) => {
  const handleReceiveConfirm = (asnId: number, comment?: string, isReserve?: boolean) => {
    // Usamos el asnId para verificar que coincida con el ASN actual
    if (receivedExternalModalState.extendedProps && receivedExternalModalState.extendedProps.asnId === asnId) {
      onReceive(receivedExternalModalState.extendedProps, comment, isReserve)
    }
  }

  return (
    <Modal
      open={receivedExternalModalState.isOpen}
      maxWidth={receivedExternalModalState.size}
      title={receivedExternalModalState.title}
      onClose={receivedExternalModalState.closeModal}
    >
      {receivedExternalModalState.extendedProps && (
        <ModalAsnReceived
          asnId={receivedExternalModalState.extendedProps.asnId}
          handleCloseModal={receivedExternalModalState.closeModal}
          handleSubmitAction={handleReceiveConfirm}
          isLoading={isLoading}
        />
      )}
    </Modal>
  )
}

